<script lang="ts">
	let className = '';
	export { className as class };

	export let tag = 'h2';
</script>

<svelte:element
	this={tag}
	class="mb-3 mt-12 lg:mb-6 lg:mt-24 text-gray-1 text-secondary font-extrabold italic {className}"
	{...$$restProps}
>
	<slot />
</svelte:element>
